/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidacyCvStore } from '../../axios/candidacyCvStore'
import type {
	CandidacyCvStoreError,
	CandidacyCvStorePathParams,
	CandidacyCvStoreRequest,
	CandidacyCvStoreResponse,
} from '../../types/CandidacyCvStore'

export const candidacyCvStoreMutationKey = () =>
	[{ url: '/candidate-center/organisations/:organisation/candidacies/:candidacy/cv' }] as const

export type CandidacyCvStoreMutationKey = ReturnType<typeof candidacyCvStoreMutationKey>

export type CandidacyCvStoreVariables = {
	organisation: CandidacyCvStorePathParams['organisation']
	candidacy: CandidacyCvStorePathParams['candidacy']
	data: CandidacyCvStoreRequest
}

/** @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyCvController.php CandidacyCvController::store */
export function useCandidacyCvStore<TContext = unknown>(
	options?: UseMutationOptions<
		CandidacyCvStoreResponse,
		AxiosError<CandidacyCvStoreError>,
		CandidacyCvStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidacyCvStoreMutationKey(),
		mutationFn: ({ organisation, candidacy, data }: CandidacyCvStoreVariables) =>
			candidacyCvStore(organisation, candidacy, data, config).then(res => res.data),
		...options,
	})
}
